// extracted by mini-css-extract-plugin
export default {"link":"GoBack_link__s+24c"};